<app-button-close-dialog></app-button-close-dialog>
<h2 mat-dialog-title>Acción realizada :: <strong>{{ data.accion == accionesDialog.Agregar ? 'Crear' : data.accion ==
    accionesDialog.Eliminar ? 'Eliminar': data.accion == accionesDialog.Ver
    ? 'Ver' : 'Modificar' }} </strong></h2>

<ngx-spinner [zIndex]="100" name="spUsuario" bdColor="rgba(255,255,255,0.8)" size="default"
  color=" var(--primary-color)" type="ball-atom" [fullScreen]="false">
</ngx-spinner>

<mat-dialog-content cdkTrapFocus [cdkTrapFocusAutoCapture]="true" *ngIf="data.accion != accionesDialog.Ver">

  <form [formGroup]="form">
    <ng-container *ngIf="data.accion == accionesDialog.Eliminar; else formTemplate">
      ¿Esta seguro que desea eliminar el registro <b>{{data.descripcion}}</b>?
    </ng-container>

    <ng-template #formTemplate>
      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>Fecha</mat-label>
            <input matInput [matDatepicker]="pickerFecha" formControlName="Fecha" />
            <mat-datepicker-toggle matSuffix [for]="pickerFecha"></mat-datepicker-toggle>
            <mat-datepicker #pickerFecha></mat-datepicker>
            <mat-error *ngIf="form.controls['Fecha'].hasError('required')">Este campo es
              <strong>requerida</strong></mat-error>
          </mat-form-field>
        </div>

        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>Motivo</mat-label>
            <input matInput type="text" maxlength="100" formControlName="Motivo" />
            <mat-error *ngIf="form.controls['Motivo'].hasError('required')">Este campo es
              <strong>requerido</strong></mat-error>
            <mat-error *ngIf="form.controls['Motivo'].hasError('maxlength')">Superó el máximo de caracteres.</mat-error>
          </mat-form-field>
        </div>

        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>Horario Desde</mat-label>
            <input matInput type="time" formControlName="HorarioDesde" />
          </mat-form-field>
        </div>

        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>Horario Hasta</mat-label>
            <input matInput type="time" formControlName="HorarioHasta" />
          </mat-form-field>
        </div>
      </div>

      <div class="row">

        <div class="col">
          <app-autocomplete-generico [label]="'Buscar Jurisdiccion'" [datos]="jurisdicciones"
            [mostrarPropiedad]="'descripcion'" [showSpinner]="showSpinnerJurisdicciones" [nombreSpinner]="'spBusquedaJurisdiccion'"
            [idPropiedad]="'id'" formControlName="IdJurisdiccion" [habilitado]="jurisdicciones?.length > 0" (seleccionar)="onSeleccionarJurisdiccion($event)">
          </app-autocomplete-generico>
        </div>

        <div class="col">
          <app-autocomplete-generico [label]="'Buscar Fuero'" [datos]="fueros" [mostrarPropiedad]="'descripcion'"
            [idPropiedad]="'id'" formControlName="IdFuero" [habilitado]="fueros?.length > 0" [showSpinner]="showSpinnerFueros"
            [nombreSpinner]="'spBusquedaFueros'" (seleccionar)="onSeleccionarFuero($event)">
          </app-autocomplete-generico>
        </div>

        <div class="col">
          <app-autocomplete-generico [label]="'Buscar Juzgado'" [datos]="juzgados" [mostrarPropiedad]="'descripcion'"
            [idPropiedad]="'id'" formControlName="IdJuzgado" [habilitado]="juzgados?.length > 0"
            [showSpinner]="showSpinnerJuzgados" [nombreSpinner]="'spBusquedaJuzgados'"
            (seleccionar)="onSeleccionarJuzgado($event)">
          </app-autocomplete-generico>
        </div>


      </div>

      <div class="row">
        <div class="col">
          <mat-checkbox formControlName="EsHabil">Es Hábil</mat-checkbox>
        </div>

        <div class="col">
          <mat-checkbox formControlName="EsFeriado">Es Feriado</mat-checkbox>
        </div>

        <div class="col">
          <mat-checkbox formControlName="EsFeriaJudicial">Es Feria Judicial</mat-checkbox>
        </div>
      </div>

    </ng-template>
  </form>


</mat-dialog-content>

<mat-dialog-content cdkTrapFocus [cdkTrapFocusAutoCapture]="true" *ngIf="data.accion == accionesDialog.Ver">

  <div *ngIf="data">
    <div class="row">

      <div class="col">
        <mat-card appearance="outlined">
          <mat-card-header>
            <mat-card-title>Información de la Fecha</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="property-row">
              <span class="property-name">Fecha:</span>
              <span class="property-value">{{ data?.fecha | date: 'dd/MM/yyyy' }}</span>
            </div>
            <div class="property-row">
              <span class="property-name">Es Hábil:</span>
              <span class="property-value">{{ data?.esHabil ? 'Sí' : 'No' }}</span>
            </div>
            <div class="property-row">
              <span class="property-name">Es Feriado:</span>
              <span class="property-value">{{ data?.esFeriado ? 'Sí' : 'No' }}</span>
            </div>
            <div class="property-row">
              <span class="property-name">Es Feria Judicial:</span>
              <span class="property-value">{{ data?.esFeriaJudicial ? 'Sí' : 'No' }}</span>
            </div>
            <div class="property-row">
              <span class="property-name">Motivo:</span>
              <span class="property-value">{{ data?.motivo }}</span>
            </div>
          </mat-card-content>
        </mat-card>
      </div>

      <div class="col">
        <mat-card appearance="outlined">
          <mat-card-header>
            <mat-card-title>Información de Jurisdicción</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="property-row">
              <span class="property-name">Jurisdicción:</span>
              <span class="property-value">{{ data?.jurisdiccion?.descripcion }}</span>
            </div>
            <div class="property-row">
              <span class="property-name">Fuero:</span>
              <span class="property-value">{{ data?.fuero?.descripcion }}</span>
            </div>
            <div class="property-row">
              <span class="property-name">Juzgado:</span>
              <span class="property-value">{{ data?.juzgado?.descripcion }}</span>
            </div>
          </mat-card-content>
        </mat-card>
      </div>

      <div class="col">
        <mat-card appearance="outlined">
          <mat-card-header>
            <mat-card-title>Horarios</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="property-row">
              <span class="property-name">Horario Desde:</span>
              <span class="property-value">{{ data?.horarioDesde | date: 'HH:mm' }}</span>
            </div>
            <div class="property-row">
              <span class="property-name">Horario Hasta:</span>
              <span class="property-value">{{ data?.horarioHasta | date: 'HH:mm' }}</span>
            </div>
          </mat-card-content>
        </mat-card>
      </div>

    </div>
  </div>

</mat-dialog-content>


<mat-dialog-actions align="end">
  <app-button-cancel-dialog></app-button-cancel-dialog>
  <app-button-add *ngIf="data.accion == accionesDialog.Agregar" [disabled]="!form.valid"
    (click)="agregar()"></app-button-add>

  <app-button-save [disabled]="!form.valid" [isDialogClose]="true" (saveClicked)="modificar()"
    (cancelClicked)="cancelar()" *ngIf="data.accion == accionesDialog.Modificar"></app-button-save>

  <app-button-delete (click)="eliminar()" (cancelClicked)="cancelar()" *ngIf="data.accion == accionesDialog.Eliminar"
    [isDialogClose]="true"></app-button-delete>
</mat-dialog-actions>
